import { actions } from './slice'

import type { KycStatus } from './types'
import type { TypedThunk } from 'src/store'
import type { GetConfirmedKycInfoResponseBody as GetConfirmedKYCInfoResponseBody } from 'temp/fraud/client'

const { setKycData, setKycLoading, setKycStatus, clearKyc } = actions

export { setKycStatus, clearKyc }

export const getConfirmedKycInfo =
  (): TypedThunk<Promise<GetConfirmedKYCInfoResponseBody | null>> =>
  (dispatch, _getState, { fraud, errorHandler }) => {
    dispatch(setKycLoading({ isLoading: true }))

    return fraud
      .getConfirmedKycInfoRequest({})
      .then((body) => {
        const { kycStatus, kycInfo, kyc } = body

        dispatch(
          setKycData({
            status: kycStatus as KycStatus,
            info: kycInfo,
            kyc: kyc,
          }),
        )

        return body
      })
      .catch((err) => {
        dispatch(errorHandler(err, { type: 'GetConfirmedKYCInfoRequest' }))

        return null
      })
      .finally(() => {
        dispatch(setKycLoading({ isLoading: false }))
      })
  }
